import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=18d343cb&"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports